let recipesFiltered = [];
let countPerPage = 9;
let currentPage = 1;
let pageLength = 0;
let scrollRecipe = false;

function calcPagination(c, m) {
    var current = c,
    last = m,
    delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l;

    for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
            range.push(i);
        }
    }

    for (let i of range) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    }

    return rangeWithDots;
}

function renderPagination() {

    pageLength = Math.ceil(recipesFiltered.length / countPerPage);
    let paginations = calcPagination(currentPage, pageLength);

    if (pageLength == 0) {
        $('#blogsNoResult').show();
        $('#blogsFilterList').hide();

    } else {
        $('#blogsNoResult').hide();
        $('#blogsFilterList').show();
    }

    if (pageLength <= 1) {
        $('#pagination').hide();
        
    } else {
        $('#pagination').show();
    }

    $('#pagination #paginationNums').html('');

    if (currentPage > 1 && pageLength != 0) {
        $('#pagination .pagination-item-prev').show();

    } else {
        $('#pagination .pagination-item-prev').hide();
    }

    for(let index = 0; index < paginations.length; index ++) {

        if (paginations[index] == '...') {
            $('#pagination #paginationNums').append('<span class="pagination-item-dots"><img class="pagination-img" src="' + iconPaginationDots + '"></span>');

        } else {

            if (currentPage == paginations[index]) {
                $('#pagination #paginationNums').append('<span class="pagination-item --active" data-page="' + paginations[index] + '">' + paginations[index] + '</span>');
    
            } else {
                $('#pagination #paginationNums').append('<span class="pagination-item" data-page="' + paginations[index] + '">' + paginations[index] + '</span>');
            }
        }
    }

    if (currentPage != pageLength && pageLength != 0) {
        $('#pagination .pagination-item-next').show();

    } else {
        $('#pagination .pagination-item-next').hide();
    }
}

$(document).on('click', '.pagination-item', function() {
    $('.pagination-item').removeClass('--active');
    $(this).addClass('--active');

    currentPage = parseInt($(this).attr('data-page'));

    scrollRecipe = true;

    renderPagination();
    showPage(currentPage);
})

$(document).on('click', '.pagination-item-prev', function() {

    currentPage --;

    if (currentPage < 1) {
        currentPage = 1;
    }

    scrollRecipe = true;

    renderPagination();
    showPage(currentPage);

    $('.pagination-item').removeClass('--active');
    $('.pagination-item[data-page="' + currentPage + '"]').addClass('--active');
})

$(document).on('click', '.pagination-item-next', function() {

    currentPage ++;

    if (currentPage > pageLength) {
        currentPage = pageLength;
    }

    scrollRecipe = true;

    renderPagination();
    showPage(currentPage);

    $('.pagination-item').removeClass('--active');
    $('.pagination-item[data-page="' + currentPage + '"]').addClass('--active');
})

function showPage(pageNumber) {
    currentPage = pageNumber;

    $('.article-item').hide();
    let startIndex = countPerPage * (currentPage -1);
    let endIndex = startIndex + countPerPage;
    
    for(let index = startIndex; index < endIndex; index ++) {
        $('.article-item[data-id="' + recipesFiltered[index] + '"]').show()
    }

    if (scrollRecipe) {

        if (pageLength != 0) {
            $('html, body').animate({
                // scrollTop: $('.article-item[data-id="' + recipesFiltered[startIndex] + '"]').offset().top - $('.header-wrapper').outerHeight() - 50,
                scrollTop: $('.blogs-list-filter-wrap').offset().top - $('.header-wrapper').outerHeight() - 50,
            });
        }
    }

    scrollRecipe = false;
}

function filterRecipes() {
    let category = $('#categories').val();
    let search = $('#search').val();
    recipesFiltered = [];

    category = category.replace('&', '&amp;')

    RECIPES.forEach((recipe) => {
        let matchSearch = false;
        let matchCategory = false;

        if (category == '') {
            matchCategory = true;

        } else if (recipe.categories.toLowerCase().includes(category.toLowerCase())) {
            matchCategory = true;
        }

        if (search == '') {
            matchSearch = true;

        } else if (recipe.title.toLowerCase().includes(search.toLowerCase()) || recipe.tags.toLowerCase().includes(search.toLowerCase()) || recipe.categories.toLowerCase().includes(search.toLowerCase())) {
            matchSearch = true;
        }

        if (matchSearch && matchCategory) {
            recipesFiltered.push(recipe.id)
        }
    })

    renderPagination();
    showPage(1);
}

filterRecipes();

$(document).on('change', '#categories', function() {
    scrollRecipe = true;
    filterRecipes();
})

$(document).on('keyup', '#search', function() {
    // scrollRecipe = true;
    filterRecipes();
})

$(document).on('click', '#blogsFilterList .rcp-tag-item', function() {
    scrollRecipe = true;
    let category = $(this).text();
    $('#categories').val(category);
    filterRecipes();
})